import NotificationPreferencesEditor from '@koob/profile/src/components/NotificationPreferencesEditor';
import { useAsync } from 'react-async';
import { KoobButton } from '@koob/ui';
import { useEffect, useState } from 'react';
import { useSnack } from '../../../hooks';
import {
  getUserNotificationPreferences,
  updateUserNotificationPreferences,
} from '../../../api/users';

export default function ProfileNotificationPreferences({ userId }) {
  const { notify } = useSnack();

  const { data: preferencesData, isLoading } = useAsync({
    promiseFn: getUserNotificationPreferences,
    userId: userId,
  });
  const notificationPreferences = preferencesData?.data || [];

  const [preferences, setPreferences] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setPreferences(notificationPreferences);
  }, [notificationPreferences]);

  const updatePreferences = async () => {
    setIsSaving(true);

    try {
      const newPreferences = await updateUserNotificationPreferences(
        userId,
        preferences,
      );
      setPreferences(newPreferences.data);
      notify('Notification preferences updated successfully');
    } catch (error) {
      notify('Failed to update notification preferences', { type: 'error' });
      console.error('Failed to update notification preferences:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <NotificationPreferencesEditor
        loading={isLoading}
        preferences={preferences}
        setPreferences={setPreferences}
      />

      <div className="mt-3">
        <KoobButton onClick={updatePreferences} loading={isLoading || isSaving}>
          Save Preferences
        </KoobButton>
      </div>
    </div>
  );
}
